import { ENDPOINT_PROFILE } from '../config'
import type { ProfileResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Get current user's profile information
 */
const getProfile = async (): Promise<ProfileResponse> => {
  const response = await AuthAxios.get<ProfileResponse>(ENDPOINT_PROFILE)
  return response.data
}

export default getProfile
